import { Link } from "@tanstack/react-router";
import { usePageTitle } from "@/routes/__root";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/components/site/PageHero";
import { Section, SectionHeading } from "@/components/site/Section";


const principles = [
  ["Numbers before narrative", "A deal either survives the spreadsheet or it does not. Nothing else counts."],
  ["Teach the method", "We hand over the framework, not a dependency. Every member should outgrow us."],
  ["Published pricing", "Every fee, tier and percentage is on this website. No discovery-call pricing games."],
];

export function AboutPage() {
  usePageTitle("About");
  return (
    <>
      <PageHero
        eyebrow="About"
        title="Property investing, taught like a discipline"
        subtitle="Sir Levantine Limited exists to close the gap between property content and property competence — with tooling, teaching and a sourcing desk under one roof."
      />

      <Section>
        <div className="grid gap-14 lg:grid-cols-[1fr_1.2fr]">
          <SectionHeading eyebrow="The founder" title="Built by an operator, not a marketer" />
          <div className="space-y-5 text-base leading-relaxed text-muted-foreground">
            <p>
              The Academy grew out of a working UK portfolio and the underwriting model used to
              build it. What started as a private spreadsheet became a set of frameworks, then a
              video curriculum, and now the AI Deal Analyzer that members use every day.
            </p>
            <p>
              We kept the entry price at £10 a month deliberately. The tooling and education should
              be affordable to anyone serious; the higher tiers exist for investors who want time,
              access and a sourcing team rather than more information.
            </p>
            <p>
              Sir Levantine Limited is a UK registered company. We are an education and sourcing
              business — we do not provide regulated financial advice, and every projection we
              publish is an estimate.
            </p>
          </div>
        </div>
      </Section>

      <Section ink className="py-20">
        <SectionHeading light eyebrow="Principles" title="How we operate" />
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {principles.map(([t, b]) => (
            <div
              key={t}
              className="rounded-lg border border-ink-foreground/15 bg-ink-foreground/5 p-7"
            >
              <h3 className="text-xl text-ink-foreground">{t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-foreground/70">{b}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap gap-3">
          <Button asChild variant="gold" size="xl">
            <Link to="/signup">Join the Academy</Link>
          </Button>
          <Button asChild variant="outlineLight" size="xl">
            <Link to="/blueprint">Read the Blueprint</Link>
          </Button>
        </div>
      </Section>
    </>
  );
}
